module.exports = __webpack_public_path__ + "img/background.a1408332.png";